import { Component, OnInit } from '@angular/core';

import { AccountService } from '../../services/account/account.service';
import { environment } from '../../../environments/environment';
import { MyAccount } from '../../models/my-account';
import { ScrollPositionService } from './scroll-position.service';
import { dateStringFromISO8601 } from '../../utils';

// The URL path the app was opened at, captured at module load. This must be
// read before the router's initial navigation, which rewrites unknown URLs
// (including /local-login) to /home via the wildcard route.
const INITIAL_PATH = window.location.pathname;

@Component({
  selector: 'app-root',
  templateUrl: './staff-site.component.html',
  styleUrls: ['./staff-site.component.css']
})
export class StaffSiteComponent implements OnInit {
  constructor(
    public accountService: AccountService,
    private scrollPositionService: ScrollPositionService
  ) {}

  ngOnInit() {
    // Scroll-on-navigation is handled by this service rather than the router,
    // so that moving between the tabs of one customer's profile keeps the
    // page where it is. Started here, before the first navigation completes.
    this.scrollPositionService.init();

    // Opening the Staff Site at /local-login triggers a credential-less
    // local-development login. This is handled here rather than by a routed
    // component because the router outlet does not render until the user is
    // logged in. Outside of local development this is inert: the backend
    // endpoint only exists when the server runs with CENV=local.
    if (
      environment.local &&
      INITIAL_PATH === '/local-login' &&
      !this.accountService.isLoggedIn()
    ) {
      this.accountService
        .localLogin()
        .catch(reason => { console.error('Local login failed:', reason); });
    }
  }

  public permissionCheck(myAccount: MyAccount): string {
    if (!myAccount.can_log_in_to_staff_site) {
      return 'This account does not have permission to log into the Staff Site. Contact your account administrator for more information.';
    }

    if (!myAccount.can_manage_members) {
      return 'The "Can Manage Customers" permission is required in order to log in to the Staff Site.';
    }

    return '';
  }

  public shutdownBannerText(): string {
    const myAccount = this.accountService.getMyAccount();
    if (!myAccount) { return ''; }

    const now = Date.now();
    const isInEffect = (shutDownAt: string | null) =>
      !!shutDownAt && new Date(shutDownAt).getTime() <= now;

    if (isInEffect(myAccount.organization_shut_down_at)) {
      return 'This organization\'s Capitan account has been closed since ' +
        dateStringFromISO8601(myAccount.organization_shut_down_at) + '.';
    }
    if (isInEffect(myAccount.organization_climber_app_shut_down_at)) {
      return 'This organization\'s Climber App has been shut down since ' +
        dateStringFromISO8601(myAccount.organization_climber_app_shut_down_at) + '.';
    }
    return '';
  }
}
